import './App.scss';
import Header from './components/Header/Header';
import BookingPage from './pages/BookingPage/BookingPage';
import HomePage from './pages/HomePage/HomePage';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

function Layout() {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" element={<HomePage />} />
      <Route path="/booking" element={<BookingPage />} />
    </Routes>
  )
}


function App() {

  return (
    <Router>
      <div className="App">
        <Header />
        <Layout />
      </div>
    </Router>

  );
}

export default App;
